import Vue from 'vue'
import Loading from './src/main.vue'

// dom上的num属性是用来记录被打开了几个
Loading.install = () => {
  if (document.querySelector('.leon-loading')) {    // 检测到有就不添加了
    // 如果存在了就累计计数
    let dom = document.querySelector('.leon-loading')
    let num = dom.getAttribute('num') * 1 + 1
    dom.setAttribute('num', num)
    return
  }

  const Loadings = Vue.extend(Loading)
  const component = new Loadings().$mount()
  component.$el.setAttribute('num', 1)
  document.querySelector('body').style.overflow = 'hidden'
  document.querySelector('body').appendChild(component.$el)
}
// 这是关闭遮罩
// dom上的num属性是用来记录被打开了几个
Loading.install.close = () => {
  let dom = document.querySelector('.leon-loading')
  if (!dom) {
    return
  }
  let num = dom.getAttribute('num') * 1
  
  // 等于1代表只剩余这一个了
  if (num === 1) {
    document.querySelector('body').style.overflow = 'visible'
    document.querySelector('body').removeChild(dom)
  } else {
    dom.setAttribute('num', --num)
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/plugin/LeonLoading/index.js